import { useActiveEncounterState, useBlocks } from "../state/graph-hooks";
import { Entity3D } from "./entity-3d";

export function EntityRenderer() {
  const blocks = useBlocks();
  const encounter = useActiveEncounterState();

  return (
    <group name="entity-renderer">
      {blocks.map((id) => (
        <Entity3D key={id} id={id} encounter={encounter ?? null} />
      ))}
    </group>
  );
}
